import React from 'react';
type Variant = 'primary' | 'outline' | 'light' | 'ghost';
type Size = 'md' | 'lg';
const variants: Record<Variant, string> = {
  primary: 'bg-plum-900 text-ivory shadow-soft hover:bg-plum-800 hover:shadow-lift focus-visible:outline-plum-900',
  outline: 'bg-ivory/70 text-plum-800 border border-lavender-200 hover:border-lavender-300 hover:bg-ivory hover:shadow-soft focus-visible:outline-plum-700',
  light: 'bg-ivory text-plum-800 shadow-soft hover:bg-lavender-50 focus-visible:outline-lavender-200',
  ghost: 'bg-transparent text-ivory border border-ivory/35 hover:bg-ivory/10 focus-visible:outline-ivory'
};
const sizes: Record<Size, string> = {
  md: 'px-5 py-3 text-sm',
  lg: 'px-7 py-4 text-[0.95rem]'
};
const base = 'group inline-flex items-center justify-center gap-2 rounded-pill font-medium tracking-[0.01em] transition-[background-color,border-color,color,box-shadow,transform] duration-200 ease-premium hover:-translate-y-[1px] active:translate-y-0 active:scale-[0.99] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none disabled:opacity-60';
function classes(variant: Variant, size: Size, className: string) {
  return `${base} ${variants[variant]} ${sizes[size]} ${className}`;
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  analyticsId?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  analyticsId,
  className = '',
  children,
  ...rest
}: ButtonProps) {
  return <button data-analytics-id={analyticsId} className={classes(variant, size, className)} {...rest} data-id="element-1" data-mp="3ufubea0jngvz">
      {children}
    </button>;
}
interface ButtonLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  variant?: Variant;
  size?: Size;
  analyticsId?: string;
  /** Los enlaces externos (WhatsApp) se abren en una pestaña nueva. */
  external?: boolean;
}
export function ButtonLink({
  href,
  variant = 'primary',
  size = 'md',
  analyticsId,
  external = true,
  className = '',
  children,
  ...rest
}: ButtonLinkProps) {
  return <a href={href} data-analytics-id={analyticsId} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className={classes(variant, size, className)} {...rest} data-id="element-2" data-mp="1dbq8ogj6loxa">
      {children}
    </a>;
}